export const transactionPriority = {
    Sales: 1,
    'Sales - Tax exempt': 2,
    'Shipping revenue': 3,
    'Shipping revenue - Tax exempt': 4,
    Refunds: 5,
    'Refunds - Tax exempt': 6,
    'Transaction fees': 7,
    'Transaction fees - Tax exempt': 8,
    'Gift cards': 9,
    'Pending payments': 10,
    'Tax collected': 11,
};
